export default {
    data (){
        return {
            isFavorite: false,
            isCompetitionFavorite: false,
            favorites: [],
            competitionFavorites: []
        }
    },
    mounted () {
        this.fetchFav();
    },
    methods: {
        saveFavorite(id, type = 1) {
            this.$http.post(api + 'api/v1/favorite/save', {type: type, id: id}).then(response => {
                this.sportMarkets = response.body;
            });
        },
        removeFavorite(id, type = 1) {
            this.$http.post(api + 'api/v1/favorite/remove', {type: type, id: id}).then(response => {
                this.sportMarkets = response.body;
            });
        },
        saveCompetitionFavorite(id, type = 1) {
            this.$http.post(api + 'api/v1/favorite/save', {type: type, id: id}).then(response => {
                this.sportMarkets = response.body;
            });
        },
        removeCompetitionFavorite(id, type = 2) {
            this.$http.post(api + 'api/v1/favorite/remove', {type: type, id: id}).then(response => {
                this.sportMarkets = response.body;
            });
        },
        addFav(match) {
            var self = this;
            this.$getItem('fav', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                }

                if( value.includes(match.matchId) ) {
                    value.remove(match.matchId);
                    this.removeFavorite(match.matchId);

                }else{
                    this.saveFavorite(match.matchId);

                    value.push(match.matchId);
                }
                self.favorites = value;
                //console.log(value);
                self.updateFav(value);

            }, function (err) {

                self.$setItem('fav', []);
            })
        },
        addCompetitionFav(comp) {

            this.isCompetitionFavorite = (this.isCompetitionFavorite) ? false : true;

            var self = this;
            this.$getItem('competitionFav', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                }

                if( value.includes(comp.id) ) {
                    value.remove(comp.id);
                    this.removeCompetitionFavorite(comp.id);

                }else{
                    this.saveCompetitionFavorite(comp.id, 2);

                    value.push(comp.id);
                }
                self.competitionFavorites = value;
                //console.log(value);
                self.updateCompetitionFav(value);



            }, function (err) {

                self.$setItem('competitionFav', []);
            })
        },
        removeAllFav () {
            var self = this;
            this.$setItem('fav', [], (key, value) => {
                self.$bus.$emit('removedAllFav', []);
            });
        },
        updateCompetitionFav (f) {
            var self = this;
            this.$setItem('competitionFav', f, (key, value) => {
                self.$bus.$emit('competitionFav', f);
            });
        },
        updateFav (f) {
            var self = this;
            this.$setItem('fav', f, (key, value) => {
                self.$bus.$emit('addFav', f);
            });
        },
        checkIsCompetitionFavorite(m){
            var self = this;
            this.$getItem('competitionFav', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                }

                if( value.includes(m.id) ) {
                    self.isCompetitionFavorite = true;

                }else{

                    self.isCompetitionFavorite = false;
                }

            }, function (err) {

            })
        },
        checkIsFavorite(m){
            var self = this;
            this.$getItem('fav', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                }

                if( value.includes(m.matchId) ) {
                    self.isFavorite = true;

                }else{

                    self.isFavorite = false;
                }

            }, function (err) {

            })
        },
        getFavorites(){

            this.fetchFav();

            return this.favorites;
        },
        fetchFav(){
            var self = this;
            this.$getItem('fav', (key, value) => {
                //console.log all the kay/value pairs

                self.favorites = value;

            }, function (err) {

            })
        }
    }
}

Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};


// WEBPACK FOOTER //
// ./src/mixins/favorite.js